<template>

  
    <div id="contain" >
      <div class="top">
        <div class="notRecovered">

          <div class="notRecovered_top">
              <span class="notRe">
                		￥ 投入总资金
              </span>
              <img src="../assets/fresh.gif" alt="" v-if="fresh" >
              <img src="../assets/fresh.png" alt="" v-if="noFresh"  @click="freshCap()">
          </div>
          <div class="notRecovered_bottom">
                <img src="../assets/1.png" alt="">
                <div class="ReData">
                    <span class="Renum" :style="'font-size:'+ 30*fontH+'px;'">{{capital.firstRecords}}</span><span class="Redan"></span>
                </div>
                
          </div>
          <div class="clear"></div>
          <div class="bottom">  </div>
        </div>
        <!--第二个-->
        <div class="recovered">
           <div class="notRecovered_top">
              <span class="notRe">
                		￥ 已使用总资金
              </span>
              <img src="../assets/fresh.gif" alt="" v-if="fresh">
              <img src="../assets/fresh.png" alt="" v-if="noFresh"  @click="freshCap()">
          </div>
          <div class="notRecovered_bottom">
                <img src="../assets/2.png" alt="">
                <div class="ReData">
                    <span class="Renum" :style="'font-size:'+ 30*fontH+'px;'">{{capital.usedAmount}}</span><span class="Redan"></span>
                </div>
                
          </div>
          <div class="clear"></div>
          <div class="bottom">  </div>
        </div>
         <!--第三个-->
        <div class="inwentory">
           <div class="notRecovered_top">
              <span class="notRe">
                		￥ 未使用资金
              </span>
              <img src="../assets/fresh.gif" alt="" v-if="fresh">
              <img src="../assets/fresh.png" alt="" v-if="noFresh"  @click="freshCap()">
          </div>
          <div class="notRecovered_bottom">
                <img src="../assets/3.png" alt="">
                <div class="ReData">
                    <span class="Renum" :style="'font-size:'+ 30*fontH+'px;'">{{capital.totalAmount}}</span><span class="Redan"></span>
                </div>
                
          </div>
          <div class="clear"></div>
          <div class="bottom">  </div>
        </div>
         <!--第四个-->
        <div class="invest_capital">
          <div class="notRecovered_top">
              <span class="notRe">
                		￥累计使用总资金
              </span>
              <img src="../assets/fresh.gif" alt="" v-if="fresh">
              <img src="../assets/fresh.png" alt="" v-if="noFresh"  @click="freshCap()">
          </div>
          <div class="notRecovered_bottom">
                <img src="../assets/4.png" alt="">
                <div class="ReData">
                  <span class="Renum" :style="'font-size:'+ 30*fontH+'px;'">{{capital.sumRecords}}</span><span class="Redan"></span>
                </div>   
          </div>
          <div class="clear"></div>
          <div class="bottom">  </div>
        </div>


      </div>
      <!-- 中间部分 -->
      <div class="center_progress">
        <ul>
          <li class="hover"><img src="../assets/shop.jpg" alt="">
              门店
          </li>
          <li class="height"><img src="../assets/strightLine.png" alt="">
            
          </li>
          <li class="hover" @click="branch()"><img src="../assets/branch.jpg" alt="">
            支线在途
          </li>
          <li class="arrows"><img src="../assets/arrows.png" alt="">
           
          </li>
          <li class="hover" @click="warehouse()"><img src="../assets/warehouse.jpg" alt="">
            仓库
          </li>
          <li class="height"><img src="../assets/strightLine.png" alt=""></li>
          <li class="hover"  @click="artery()" ><img class="artery_img" src="../assets/artery.jpg" alt="">
             干线在途
          </li>
          <li class="arrows"><img src="../assets/arrows.png" alt=""></li>
          <li class="hover" @click="smeltShow()"><img src="../assets/smelting.jpg" alt="">
            
            冶炼厂
          </li>
        </ul>
      </div>
      <!-- 	底部表格 -->
      <div id="bottom">
        <div class="date_data">
          <div class="date_top">
            <span class="all">总</span>
            <p class="all_info">已结算总额（元）</p>
            <p id="all_num">{{actualAmount}}</p>
          </div>
          <div v-if="smelting">
            <p><button class="search" @click="search()">查询数据</button></p>
            <p>
                <select name="" id="select" v-model="smeltPSele"  @click="selectSmelt()" >
                  <option value="">请选择冶炼厂</option>
                  <option v-for="smeltPlant in smeltPlants" v-bind:value="smeltPlant.saCustId"  >{{smeltPlant.companyName}}</option>
                </select>              
            </p>
            <div id="test1">
               {{smeltPSele.companyName}}
                <fooDate :par-smelt="smeltPSele0" @upup="change" :msg="msg"></fooDate>
            </div>
          </div>
          
        </div>
        <div class="table">
          <table>
            <tr>
              <th>产品品类</th>
              <th>仓库名称产品品类</th>
              <th v-if="infoDate">日期</th>
              <th>总数量</th>
              <th>总金额</th>
              <!-- <th ng-if="infoCompany">公司名称</th> -->
              <th>总重量</th>
            </tr>
            <tr v-for="smlet in smeltData">
              <td>{{smlet.commTypeName}}</td>
              <td>{{smlet.warehouseName}}</td>
              <td v-if="infoDate">{{smlet.signDate}}</td>
              <td>{{smlet.totalQuantity}}</td>
              <td>{{smlet.totalCost}}</td>
              <!-- <td>{{smlet.companyName}}</td> -->
              <td>{{smlet.totalWeight}}</td>
            </tr>
            
          </table>
          <div class="cr_bottom">
            <div id="next" @click="next()">下一页</div>
            <div class="different_b"><span class="current">{{pageNo}}</span>/ <span class="all_num">{{pageAll}}</span></div>
            <div @click="prve()">上一页</div>
          </div>
        </div>
      </div>

    </div>
 
</template>
<script>
  import data from '../homeDataMethods/homeData'
  import methods from '../homeDataMethods/homeMethods'
  import fooDate from './Foo.vue'
  import axios from 'axios'
 
  // import http from '../providers/http'
  // import api from '../providers/api'
  export default {

    name:"Home",
    data(){
      return data;
    },
    components:{
        fooDate
    },
    mounted:function(){
         this.token = window.localStorage.getItem("token");
         this.fontH = window.innerHeight/700;
         console.log(window.innerHeight,"浏览器的内部高度+++")
         this.innerHeight = window.innerHeight;
                axios({
                method:"POST",
                url:this.urls+"/funding/getfundingStatistical",
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                  'Content-Type': 'application/json; charset=UTF-8'
                },
                data:{
                      "token":this.token
                    }
            })
            .then((res)=>{
                this.capital = res.data;
            }) 
            .catch((err)=>{
              console.log(err);
            })

    },
    computed:{
     
    },
    methods:methods

  }
</script>
<style scoped>
  .hover{
    cursor: pointer;
   
  }
.center_progress ul li{
    font-size: 20px;
    color: #66ccff;
    text-align: center;
    font-weight: 600;
    letter-spacing:3px;
}
  .top{
    width:100%;
    height: 160px;
    border: none;
  }
  .notRecovered,.recovered,.inwentory,.invest_capital{
    width: 21%;
    height: 160px;
    float: left;
    padding: 0.5%;
    /*margin-right:0.5%;*/
    border-radius: 5px;
    box-sizing: border-box;
    box-shadow: 6px 6px 3px #888888;
  }
  .notRecovered{
    background-color: #00CCFF;
  }
  .recovered{
    margin-right: 5%;
    margin-left: 5%;
    background-color: #3C9F9C;
  }
  .inwentory{
    margin-right: 5%;
    background-color: #58ABC3;
  }
  .invest_capital{
    background-color: #199ED8;
  }
  .four_orders{
    padding: 0%;
  }

  #contain{
    overflow-x: hidden;
    width: 99%;
    margin: 0 auto;
    padding: 1%;
    background-color: #F6F6F6;
    height: 98%;
  }


  .center_progress{
    width: 80%;
    height: 40px;
    margin: 0 auto;
  }

  .bottom{
    width: 100%;
      height: 8px;
    margin-top: 10px;
    box-sizing: border-box;
    float: right;
     background-color: white;
  }
  .notRecovered{
    background-color: #DF5E5E;
  }
  .ReData{
    float: right;
    margin-right: 10px;
    margin-top: 20px;
    height: 60px;
  } 
  .ReData span{
    display: block;
    float: left;
    margin-top: 15px;
   
  }
   .ReData span:nth-child(1){
     font-size: 45px;
   }
    .ReData span:nth-child(2){
     font-size: 20px;
     line-height: 80px;
     float: left;
   }
  /*   顶部第一个div内部进行控制 */
  .notRecovered_left{
    width: 40%;
    height: 80%;
    float: left;
  }
  .notRecovered_right{
    width: 60%;
    height: 80%;
    float: left;
    color: white;
    font-size: 18px;

  }
  /* 为回收订单 */

  .notRe{
    display: block;
    width: 50%;
    height: 20px;
    line-height: 20px;
    border-radius: 20px;
    text-align: center;
    float: left;
    font-size: 12px;
    color: #DF5E5E;
    background-color: white;
  }

  .notRecovered_top img{
    float: right;
    width: 20px;
    padding: 0% 3% 0 10%;
    cursor: pointer;
  }
   .notRecovered_top{
     height: 20px;
     margin-top: 1.5%;
   }
   .notRecovered_bottom{
     width:100%;
     height: 90px;
   }
   .notRecovered_bottom img{
      float: left;
     padding: 13px 0 0 45px
   }
  .notRecovered_left a{
    color: white;
    font-size: 12px;
    display: block;
    padding-left: 13%;
    padding-top: 31%;
  }
  .notRecovered_right p img{
    width: 20px;
    float: right;
    cursor: pointer;
  }
  .notRecovered_right p{
    height: 20px;
    margin: 0;
    font-size: 16px;
    text-align: right;
  }



.Redan{
  color: white;
}
 
  #reInfo{
    text-align: right;
  }

  #bottom{
    width: 100%;
    height: 60%;
    background-color: white;
  }
  .clear{
    clear: both;
  }


  /*顶部第二个*/

  .Renum{
    font-size: 45px;
    line-height: 60px;
    color: white;
  }
  #reInfo2{
    text-align: right;
  }


  #bottom2 a{
    float: left;
    text-decoration: none;
    color: white;
    padding-left: 5%;
    font-size: 10px;
  }
  #bottom2 p {
    float: right;
    color: white;
    font-size: 14px;
    margin: 0;
  }


  .Renum3{
    font-size: 45px;
    line-height: 90px;
  }
  #reInfo3{
    text-align: right;
  }
  .reInfo3{
    text-align: right;
  }




  /*顶部四个小块*/
  .four_orders ul{
    width:100%;
    height:100%;
    margin: 0;
    padding: 0;
  }
  .four_orders ul li{
    width: 49%;
    height: 48%;
    float: left;
    list-style: none;
    border-radius:3px;
  }
  .four_orders ul li div{
    width: 40%;
    height: 65%;
    color: white;
    margin: 0 auto;
    margin-top: 6.5%;
    line-height: 33px;
    text-align: center;
  }
  .four_orders ul li:nth-child(1){
    margin-right: 2%;

    background-color: #6AA6C6;
  }

  .four_orders ul li:nth-child(2){

    background-color: #4DC0B6;
  }

  .four_orders ul li:nth-child(3){
    margin-top: 2%;

    background-color: #33cc99;
  }

  .four_orders ul li:nth-child(4){
    margin-top: 2%;
    margin-left: 2%;
    background-color: #937dd9;
  }



  /* 中间右边部分 */

  .cr_top {
    width:100%;
    height:7%;
  }
  .cr_top ul{
    width: 100%;
    height: 100%;
    background-color: #A4ACC3;
    margin:0;
    padding:0;
  }
  .cr_top ul li{
    width: 14%;
    height: 30px;
    color: white;
    line-height: 30px;
    font-size: 14px;
    list-style: none;
    text-align: center;
    float: left;
  }


  /*  中间右边底部按钮 */
  .cr_bottom{
    width: 100%;
    height: 7%;
    float: right;
    background-color: #EBEBEB;
    position: absolute;
    bottom: 10px;
    left: 0;
  }
  .cr_bottom div{
    width: 80px;
    font-size:14px;
    height: 23px;
    text-align: center;
    color: white;
    float: right;
    line-height: 23px;
    border-radius: 5px;
    cursor: pointer;
    background-color: #169BD5;
    margin-top: 5px;
  }
  .cr_bottom div:nth-child(1){
    margin-right: 4%;
  }
  .cr_bottom .different_b{
    border: 1px solid #797979;
    color: black;
    border-radius: 2px;
    background-color: white;
    margin-left: 12px;
    margin-right: 12px;
  }


  /*  中间内容部分 */
  .cr_content{
    width:100%;
    height:86%;
    overflow:hidden;
  }

  #phoneN{
    width:14.25%;
  }

  /*右边中间list部分*/
  .cr_content div{
    float: left;
    width:14.25%;
    height:100%;
    cursor: pointer;
  }
  .cr_content div ul{
    width: 100%;
    height: 100%;
    margin:0;
    padding:0;
  }
  .cr_content div ul li{
    width: 100%;
    height: 9.1%;
    color:#006666;
    text-align: center;
    line-height: 30px;
    list-style: none;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  .cr_content div ul li:nth-of-type(odd){
    background-color:#F2F2F2;
  }

  .cr_content div ul li:nth-of-type(even){
    background-color:#EBEBEB;
  }

  /*  对底部进行控制 */
  table {
    border-collapse: collapse;
    width: 99%;
    text-align: center;
    border: 0px solid skyblue;
    position: relative;
  }
  table th{
    color:white;
    background-color:#59B2B2;
    font-size:14px;
    font-weight:normal;
    border: none;
  }
  table tr td{
    font-size:14px;
    color:#006666;
    border: none;
  }
  table tr{
    border: none;
    line-height: 35px;
    height: 16px;
  }
  table tr:nth-of-type(odd){
    background-color: #EBEBEB;
  }
  table tr:nth-of-type(even){
    background-color:#F2F2F2;
  }
  table, td, th {
    /*  border: 1px solid black; */

  }

  #next{
    margin-right: 1.5%;
  }

  .notRecovered_right p .refresh{
    transform: rotate(120deg) !important;
  }

  /*//对新的页面进行CSS控制*/
  .center_progress{
    width: 100%;
    height: 15%;
  }
  .center_progress ul{
    height: 100%;
  }
  .center_progress ul li:nth-of-type(1){
    margin-left: 5%;
  }
  .center_progress{
    margin-top: 5%;
    margin-bottom: 10px;
  }
  .center_progress ul li{
    float: left;
    width: 10%;
    height: 70%;
    list-style: none;
  }
  .center_progress ul li img{
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }

  .arrows,.height{
    height:30%;
    padding-top: 2%;
  }
  .center_progress ul .height img{
    height: 20%;
  }
  .center_progress ul .arrows img{
    height: 20%;
  }
  .artery_img{
    height: 100% !important;
  }
  /*//底部左边日期控件部分*/
  .date_data{
    width: 16%;
    float: left;
    height: 80%;
    margin-right: 1%;
  }

  .table{
    width: 83%;
    height: 100%;
    float: right;
    background-color: #EBEBEB;
    position: relative;
  }
  .all{
    width: 30%;
    height: 60px;
    display: block;
    background-color: #66ccff;
    text-align: center;
    line-height:60px;
    float: left;
    font-size: 32px;
    color: white;
  }

  .all_info{
    font-size: 15px;
    text-indent: 5px;
    
    color: #c7ccd8;
  }

  #all_num{
    color: #66CCFF;
    font-size: 32px;
    text-align: center;
  }

  #select{
    width: 82%;
    height: 30px;
    margin: 15px 0 15px 0;
    text-indent: 10px;
    border-radius: 4px;
  }

  #test1{
    width: 100%;
  
  }

  #layui-laydate1{
    width: 100%;
  }

/* 底部左边一结算总金额进行控制 */

.date_top{
  height: 25%;
}
.date_top p{
    margin: 0;
    padding: 0;
    text-align: left;
}

#all_num{
  text-align: left;
  text-indent: 16px;
}

.search{
    width: 84%;
    height: 30px;
    line-height: 30px;
    border-radius: 5px;
    border: none;
    color: white;
    cursor: pointer;
    background-color: #46ac49;
}












</style>



// WEBPACK FOOTER //
// src/components/Home.vue